import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Services from "../components/Services";
import Contact from "../components/Contact";

const HomePage = () => {
    return (
        <>
            <Hero />
            <Marquee />
            <About />
            <Services />
            <Contact />
        </>
    );
};

export default HomePage;
